import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../common/redux/reduxHooks";

import { MissionProCard } from "../missions/components/MissionProCard";
import { MissionStructCard } from "../missions/components/MissionStructCard";
import { Box, CircularProgress, Typography } from "@mui/material";
import { getMissionById } from "../common/redux/missionActions";
import { useTranslation } from "react-i18next";

const NotificationMissionPage = (): JSX.Element => {
    const { id } = useParams<{ id: string }>();
    const dispatch = useAppDispatch();
    const role = useAppSelector((state) => state.auth.data.roles[1]);

    const [loading, setLoading] = useState(true);
    const [mission, setMission] = useState<any>(null);
    const [error, setError] = useState(false);

    const { t } = useTranslation();

    useEffect(() => {
        if (id) {
            dispatch(getMissionById({ id, role }))
                .unwrap()
                .then(setMission)
                .catch(() => setError(true))
                .finally(() => setLoading(false));
        }
    }, [dispatch, id, role]);

    if (loading) {
        return (
            <Box
                textAlign="center"
                height="100dvh"
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexDirection="column"
            >
                <CircularProgress />
                <Typography mt={2}>{t("inputPlaceholders.loading")}</Typography>
            </Box>
        );
    }

    if (error || !mission) {
        return (
            <Box
                textAlign="center"
                height="100dvh"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Typography variant="h6" color="error">
                    {t("notification.notFound")}
                </Typography>
            </Box>
        );
    }

    const { ref, ...rest } = mission;

    return (
        <Box mt={5} display="flex" justifyContent="center" width="100%">
            {role === "ROLE_PROFESSIONNEL" ? (
                <MissionProCard {...rest} />
            ) : (
                <MissionStructCard {...rest} />
            )}
        </Box>
    );
};

export default NotificationMissionPage;
